import { Box } from "@chakra-ui/react";
import UserProfile from "views/admin/userprofile/components/UserProfile";

export default function Settings() {
  return (
    <Box pt={{ base: "130px", md: "80px", xl: "80px" }}>
      <UserProfile />
    </Box>
  );
}
